import { gql } from "@apollo/client";

export const FLOORING_UPDATE = gql`
  mutation FlooringUpdate($input: FlooringFieldsInput!) {
    flooringUpdate(input: $input) {
      label
      message
      flooring {
        id
        title
        article
        type
        color
        supplier_id
        images {
          id
          field_group
          title
          description
          sizes
          extension
          user {
            id
            name
            surname
          }
        }
      }
    }
  }
`;

export const FLOORING_CREATE = gql`
  mutation FlooringCreate($input: FlooringFieldsInput!) {
    flooringCreate(input: $input) {
      label
      message
      flooring {
        id
        title
        article
        type
        color
        supplier_id
        images {
          id
          field_group
          title
          description
          sizes
          extension
          user {
            id
            name
            surname
          }
        }
      }
    }
  }
`;

export const FLOORING_DELETE = gql`
  mutation FlooringDelete($id: ID!) {
    flooringDelete(id: $id) {
      label
      message
    }
  }
`;

export const FLOORING_VARIATION_UPDATE = gql`
  mutation FlooringVariationUpdate($input: FlooringVariationFieldsInput!) {
    flooringVariationUpdate(input: $input) {
      label
      message
      flooringVariation {
        id
        title
        article
        flooring_id
        organizer_id
        price
        price_basic
        created_at
        updated_at
        relFlooring {
          id
          title
        }
        relOrganizer {
          id
          title
        }
      }
    }
  }
`;

export const FLOORING_VARIATION_CREATE = gql`
  mutation FlooringVariationCreate($input: FlooringVariationFieldsInput!) {
    flooringVariationCreate(input: $input) {
      label
      message
      flooringVariation {
        id
        title
        article
        flooring_id
        organizer_id
        price
        price_basic
        created_at
        updated_at
        relFlooring {
          id
          title
        }
        relOrganizer {
          id
          title
        }
      }
    }
  }
`;

export const FLOORING_VARIATION_DELETE = gql`
  mutation FlooringVariationDelete($id: ID!) {
    flooringVariationDelete(id: $id) {
      label
      message
    }
  }
`;
